/**
 * Route: /settlements/payout — WP-D (Sammel-Auszahlungsseite)
 *
 * `?payoutId=` haelt einen laufenden Sammel-Auszahlungslauf ueber einen
 * Reload hinweg fest (Wiederaufnahme via GET /api/v2/commissions/:id) —
 * BatchPayoutPage.tsx liest/schreibt den Parameter selbst ueber
 * useSearch({ strict: false }) / useNavigate, analog zu
 * _auth.dashboard_.customize.tsx (?tag=).
 */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { BatchPayoutPage } from '../features/settlements/BatchPayoutPage'

const payoutSearchSchema = z.object({
  // FE-ROB-06-Muster: ein kaputter/manipulierter Query-Param darf die Seite
  // nicht crashen — im Zweifel als "kein laufender Payout" behandeln.
  payoutId: z.coerce.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/settlements/payout')({
  validateSearch: payoutSearchSchema,
  component: BatchPayoutPage,
})
